import { Box, Typography } from "@mui/material";


export function LogoMarca(){
    return <img src={'mygaslogo.png'} height={50} width={125} style={{alignSelf:"center"}} />
}